import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import AddNotifikasiModal from "components/Modals/AddNotifikasiModal";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { fetchListJabatan } from "state/jabatanActions";
import moment from "moment";
import "moment/locale/id";
moment.locale("id");

const Jabatan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const { status, message } = useSelector((state) => state.global);
  const { list_jabatan } = useSelector((state) => state.jabatan);

  useEffect(() => {
    dispatch(fetchListJabatan());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListJabatan());
  };

  const handleSubmitNotifikasi = (value) => {
    const reqData = {
      title: value.judul,
      body: value.isi,
    };

    dispatch(fetchListJabatan(reqData));
  };
  const columnsJabatan = [
    {
      name: "kode_jabatan",
      label: "Kode Jabatan",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "nama_jabatan",
      label: "Nama Jabatan",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];
  // {
  //   name: "aksi",
  //   label: "Aksi",
  //   options: {
  //     filter: false,
  //     sort: false,
  //     customBodyRender: (value, tableMeta) => {
  //       const id = tableMeta.rowData[0];
  //       return (
  //         <>
  //           <IconButton color="info" onClick={() => handleEdit(id)}>
  //             <Edit />
  //           </IconButton>
  //           <IconButton color="error" onClick={() => handleDelete(id)}>
  //             <Delete />
  //           </IconButton>
  //         </>
  //       );
  //     },
  //   },
  // },

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_jabatan.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      {/* <FlexBetween> */}
      <Header title="Jabatan" subtitle="Daftar jabatan di perusahaan." />

      {/* <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Jabatan
          </Button>
        </Box>
      </FlexBetween> */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_jabatan}
          columns={columnsJabatan}
          options={options}
        />
        <AddNotifikasiModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitNotifikasi(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
      </Box>
    </Box>
  );
};

export default Jabatan;
